<template>
  <div>
    <div class="loading" v-if="loading">
      <md-progress-spinner class="md-accent" :md-diameter="100" :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
    </div>
    <div class="loading" v-if="!loading && errorMessage !== null">
      {{errorMessage}}
    </div>
    <div class="loading" v-if="!loading && errorMessage === null">

      <md-card>
        <md-card-header>
          <div class="md-title">Cities</div>
        </md-card-header>

        <md-card-content>
          <md-table>

          <md-table-row>
            <md-table-head md-sort-name="name">Id</md-table-head>
            <md-table-head>Name</md-table-head>
            <md-table-head>Abbreviation</md-table-head>
            <md-table-head>Card</md-table-head>
          </md-table-row>

            <!--<tr class="md-table-row" v-for="city in cities" :key="city.versionedId.id" v-on:click="editCity(city)">-->
            <md-table-row v-for="city in cities" :key="city.versionedId.id" >
              <md-table-cell>{{city.versionedId.id}}</md-table-cell>


              <md-table-cell v-on:click="editCity(city)">
                <span v-if="!city.edit">{{city.name}}</span>
                <span v-if="city.edit">
                  <md-field>
                    <md-input v-focus v-model="city.name" @keyup.enter="saveCity(city)" @keyup.esc="cancelEditCity(city)"></md-input>
                    <md-icon style="color: red;" v-if="isSoftLocked(city.versionedId.id)"><md-tooltip md-direction="bottom">{{getLockedByString(city.versionedId.id)}}</md-tooltip>warning</md-icon>
                    <span class="md-helper-text">{{city.oldCity.name}}</span>
                  </md-field>
                </span>
              </md-table-cell>

              <md-table-cell>
                <span v-if="!city.edit">{{city.abbreviation}}</span>
                <span v-if="city.edit">
                  <md-field>
                    <md-input v-model="city.abbreviation" @keyup.enter="saveCity(city)" @keyup.esc="cancelEditCity(city)"></md-input>
                    <md-icon style="color: red;" v-if="isSoftLocked(city.versionedId.id)"><md-tooltip md-direction="bottom">{{getLockedByString(city.versionedId.id)}}</md-tooltip>warning</md-icon>
                    <span class="md-helper-text">{{city.oldCity.abbreviation}}</span>
                  </md-field>
                </span>
              </md-table-cell>

              <md-table-cell>
                <span v-if="!city.edit">
                  <md-icon style="margin-top: 4px;" v-if="city.cardImageId === undefined" class="md-morph-final">indeterminate_check_box</md-icon>
                  <md-icon style="margin-top: 4px;" v-if="city.cardImageId !== undefined" class="md-morph-final">check_box</md-icon>
                </span>
                <span v-if="city.edit">
                  <md-field >
                    <md-file v-model="city.newCardImageHolder" placeholder="Card Image should be 320x320" @change="city.newCardImage = $event.srcElement.files[0]" />
                  </md-field>
                </span>
              </md-table-cell>
              <md-table-cell>
                <md-button class="md-icon-button md-dense md-primary editButton" @click="editCity(city)" v-if="!city.edit"  v-bind:disabled="city.saving">
                  <md-icon class="md-morph-final">edit</md-icon>
                </md-button>
                <md-button class="md-icon-button md-dense md-primary" @click="saveCity(city)" v-if="city.edit">
                  <md-icon class="md-morph-final">save</md-icon>
                </md-button>
                <md-button class="md-icon-button md-dense md-primary" @click="cancelEditCity(city)" v-if="city.edit">
                  <md-icon class="md-morph-final">cancel</md-icon>
                </md-button>
                <span>
                  <md-icon style="margin-top: 4px;" v-if="!city.edit && isSoftLocked(city.versionedId.id)" class="md-morph-final"><md-tooltip md-direction="bottom">{{getLockedByString(city.versionedId.id)}}</md-tooltip>warning</md-icon>
                </span>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions>
          <md-button class="md-primary md-raised" @click="showNewCityDialog">Create New City</md-button>
        </md-card-actions>
      </md-card>

    </div>

    <md-dialog :md-active.sync="createCityPromptActive">
      <md-dialog-title>Create a new City</md-dialog-title>

      <div class="dialogContent">
        <md-field >
          <label>Name</label>
          <md-input v-focus ref="newObjectFirstField" v-model="newCityName"></md-input>
        </md-field>

        <md-field>
          <label>Abbreviation</label>
          <md-input v-model="newCityAbbreviation"></md-input>
        </md-field>

        <md-dialog-actions>
          <md-button class="md-primary" @click="createCityPromptActive = false">Cancel</md-button>
          <md-button class="md-primary md-raised" @click="createCity" v-bind:disabled="!dialogCreateActive">Create</md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>

    <md-snackbar md-position="center" :md-duration="8000" :md-active.sync="showSnackbar" md-persistent>
      <span>{{snackbarMessage}}</span>
      <md-button class="md-accent" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
  </div>
</template>

<script>
  var cityComparitor = function (a, b) {
    if (a.name < b.name) {
      return -1;
    } else if (a.name > b.name) {
      return 1;
    }
    return 0;
  };

  export default {
      name: 'admin-cities',
      data() {
        return {
          loading: true,
          errorMessage: null,
          cities: [],
          createCityPromptActive: false,
          newCityName: '',
          newCityAbbreviation: '',
          citySubscriptionId: null,
          showSnackbar: false,
          snackbarMessage: '',
          mutableFields: ['name', 'abbreviation']
        }
      },
      computed: {
        dialogCreateActive() {
          return this.newCityName.length >= 3 && this.newCityAbbreviation.length >= 1;
        }
      },
      created() {
        this.citySubscriptionId = this.$store.api.subscribe("CITY", null, this.cityChangeHandler);
        this.getCities();
      },
      beforeDestroy() {
        if (this.citySubscriptionId) {
          this.$store.api.unsubscribe(this.citySubscriptionId);
        }
        this.citySubscriptionId = null;
      },
      methods: {
        getCities() {
          this.loading = true;
          this.errorMessage = null;
          this.$store.api.rpcRequest('getAllCities', {}, rawCities => {
            var cities = [];
            rawCities.forEach(city => {
                cities.push(this.cityTransformer(city))
              }
            );
            cities.sort(cityComparitor);
            this.cities = cities;
            this.loading = false;
          }, errorMessage => {
            this.loading = false;
            this.errorMessage = errorMessage;
          });
        },
        showNewCityDialog() {
          this.newCityName = '';
          this.newCityAbbreviation = '';
          this.createCityPromptActive = true;
          var refs = this.$refs; setTimeout(() => this.$nextTick(() => refs.newObjectFirstField.$el.focus()), 300);
        },
        createCity() {
          this.createCityPromptActive = false;
          this.$store.api.rpcRequest('createCity', {
            name: this.newCityName,
            abbreviation: this.newCityAbbreviation
          }, newCity => {
          }, errorMessage => {
          });
        },
        cityTransformer(city) {
          city.edit = false;
          city.saving = false;
          return city;
        },
        editCity(city) {
          if (!city.edit) {
            var oldCity = Object.assign({}, city);
            city.oldCity = oldCity;
            city.newCardImageHolder = '';
            city.edit = true;
            this.$store.api.softLock(this.$route.fullPath, city.versionedId.id);
          }
        },
        cancelEditCity(city) {
          if (city.edit) {
            city.name = city.oldCity.name;
            city.abbreviation = city.oldCity.abbreviation;
            city.edit = false;
            this.$store.api.softUnlock(this.$route.fullPath, city.versionedId.id);
          }
        },
        saveCity(city) {
          if (city.newCardImage) {
            var fileReader = new FileReader();
            var context = this;
            fileReader.addEventListener("load", function () {
              context.saveCityWithImage(city, fileReader.result);
            });
            fileReader.readAsDataURL(city.newCardImage);
          } else {
            this.saveCityWithImage(city, undefined);
          }
        },
        saveCityWithImage(city, image) {
          if (city.edit) {
            this.$store.api.softUnlock(this.$route.fullPath, city.versionedId.id);
            city.edit = false;
            city.saving = true;
            this.$store.api.rpcRequest('saveCity', {
              versionedId: city.versionedId,
              name: city.name,
              abbreviation: city.abbreviation,
              cardImage: image
            }, savedCity => {
              city.saving = false;
            }, errorMessage => {
              city.edit = true;
              city.saving = false;
              this.$store.api.softLock(this.$route.fullPath, city.versionedId.id);
            });
          }
        },
        cityChangeHandler(newCity) {
          var found = false;
          this.cities.forEach(city => {
            if (city.versionedId.id === newCity.versionedId.id) {
              found = true;
              if (city.edit) {
                this.showSnackbar = true;
                this.snackbarMessage = "A city you were editing was modified!";

                this.mutableFields.forEach(fieldName => {
                  if (city[fieldName] === city.oldCity[fieldName]) {
                    city[fieldName] = newCity[fieldName];
                  } else {
                    // console.dir("did not merge " + fieldName)
                  }
                });
                Object.assign(city.versionedId, newCity.versionedId);
                Object.assign(city.oldCity, newCity);
              } else {
                Object.assign(city, newCity);
              }
            }
          });
          if (!found) {
            this.cities.push(newCity);
          }

          this.cities.sort(cityComparitor);
        },
        isSoftLocked(lockId) {
          return (this.$store.state.otherUserPageLocks[lockId] !== undefined)
        },
        getLockedByString(lockId) {
          if (this.$store.state.otherUserPageLocks[lockId] !== undefined) {
            return Object.keys(this.$store.state.otherUserPageLocks[lockId]).join(', ');
          } else {
            return "";
          }
        }
      }
    }
</script>

<style scoped>
  .dialogContent {
    padding: 24px;
  }

  .md-table-head {
    text-align: center;
  }

  button.editButton { visibility: hidden;}
  tr:hover button.editButton{ visibility: visible;}

</style>



// WEBPACK FOOTER //
// src/components/admin/Cities.vue